export default "__VITE_ASSET__Bz00xie0__"